import { ClassicType } from './../../shared/models/ClassicType';
import { Variazione } from './Variazione';
import { Files } from './../../shared/models/File';
import { Prezzo } from './Prezzo';
import { Paginazione } from './../../shared/models/paginazione';
import { Categorie } from './Categorie';
import {Tag} from "./tag";
import {DettaglioProdotto} from "./dettaglio-prodotto";
import {TranslateObj} from "../../shared/models/translatedesc";
export class Prodotto extends Paginazione {

  id?: number;
  prodotto?: string;
  nome?: string;
  descrizione?: string;
  codice?: string;
  codice_produttore?: string;
  tipoObject?: ClassicType;
  tipo?: number;
  immagine?: string;
  id_immagine?: number;
  file?: string;
  categorie?: any;
  enabled?: boolean = true;
  prezzi?: Prezzo[];
  prezzo?: number;
  files?: Files[];
  // send
  cat_id?: number;
  orderByNome?: 'asc'| 'desc' | null;
  // additional
  qty?: number;
  qta?: number; //parti
  parti?: Prodotto[];
  variazioni?: Variazione[];
  selected?: boolean;
  parte?: string;
  UrlImmagine?: string;
  Urlscheda?: string;
  Urldettagli?: string;
  //Klimaitalia
  descrizioneBreve?:string;
  catEnergetica?:string
  video?: string
  tags?: Tag[]
  scheda?: string;
  id_scheda?: number;
  filescheda?: string;
  dettagli?: DettaglioProdotto[];
  iva? : number;
  transaltedobjects?: TranslateObj [];
  traduzioni?: TranslateObj [];
  codiceAdhoc?: string;
  id_dettaglio?: number;
  dettaglio?: string;
  pdf_scheda?: string;
  filepdf_scheda?: string;
  filedettaglio?: string;
  tipi?: any;
  tipiObject?: ClassicType[];
  catEnergeticaObject?: any | any[];
  standby?: boolean;
  Urlscheda_e? : any;
  scheda_e?: string;
  id_scheda_e?: number;
  id_pdf_scheda?: any;
  sottoTitolo?: string;
  rifornimento?: number;
  correlatiObject?: Prodotto[];
  correlati?: number[];
  slug?: any | string;
  seoTitle?: any | string;
  seoMeta?: any | string;
  seoDesc?: any | string;
  materasso?: any;
  disponibilita?: any;
  updated_at?: string;
  descEnergetica?: any | string;
  stampe?:any[];
  ricambi?: any[];
  ricambiObject?: any[];
  schedaLavorazione?: any;
  distintaBase?: any;
  variazioniSelezionate?:any[];
  taglie?: any[];
  taglia?: any;
  costo?: number;
  cliente?: number;
  clienteObject?:any;

  constructor(page?:number, size?: number, cat_id?:number, orderByNome?: 'asc'| 'desc' | null, prodotto?: string, id?: number, descrizione?: string, codice?: string, codice_produttore?: string, immagine?: string, categorie?: Categorie[] | number[],prezzi?, tipo?:number){
    super(page, size);
    this.id = id;
    this.prodotto = prodotto;
    this.parte = prodotto;
    this.descrizione = descrizione;
    this.codice = codice;
    this.codice_produttore = codice_produttore;
    this.immagine = immagine;
    this.categorie = categorie;
    this.prezzi = prezzi;
    //send
    this.cat_id = cat_id;
    this.orderByNome = orderByNome;
    this.qty=1;
    this.parti = [];
    this.variazioni = [];
    this.tipo = tipo;
  }

}
